export const getCollapsibleSectionsState = state => state.collapsibleSections;
export const getCollapsibleSectionState = (state, section) =>
  getCollapsibleSectionsState(state)[section] || false;
